















































import EstablishmentList from '@/components/EstablishmentList'
import DropDownSearch from '@/components/DropDownSearch'
import utils from '@/utils.coffee'
import gql from '@/gqlService.coffee'

export default {
    "name": 'EstablishmentListFilterTeam',
    "components": {EstablishmentList, DropDownSearch}
    "props": {
        "selectable": Boolean
    }
    "computed":
        "filters": ()->
            return {
                "consultant": @consultant
                "search_string": @search_string
            }
    "data": ()->
        return {
            "search_string": ""
            "height": null
            "listHeight": null
            "consultant": {"lastname": null}
            "consultants": gql.query({
                "model": "consultant_set"
                "fields": "uid lastname firstname fullname"
            })

        }
    "methods":
        "setHeight": utils.debounce(
            ()->
                #console.log("setHeight")
                @height = (window.innerHeight-165)+ "px"
                return
            , 500)
        "consultantClicked": (data)->
            #console.log("cslt", data)
            @consultant = data or {"name": null}                
            return
    "mounted": ()->
        vm = this
        this.setHeight()
        window.addEventListener('resize', this.setHeight)
    "beforeDestroy": ()->
        window.addEventListener('resize', this.setHeight)

}
